$(document).ready(function () {

    header();
    /*
     Custom Select add down arrow
     */
    //$('form select').customSelect();
    //$('.customSelect').append('<span class="arrow"><i class="font-down-arrow"></i></span>');


    // Fill me in!

    function startupPlugins(container) {

        // $('.js-tabs:not(.js-tabs-ready)', container).addClass('js-tabs-ready').each(function () {
        //     var options = {};
        //
        //     if ('undefined' !== typeof $(this).data('active')) {
        //         options['active'] = $(this).data('active');
        //     }
        //
        //     $(this).tabs(options);
        // });

        $('.js-tabs').each(function(){
           var tabs = new Tabs({el: this})
            tabs.init();
        });


    }

    var $body = $('body');

    startupPlugins($body);
    sliders();

    $body
        .on('click', '.embed-container .play-button', function () {
            var $container = $(this).closest('.embed-container');
            $container.find('.overlay').addClass('hidden');
        })
        .on('click', '.accordion > dt > a', function () {
            var $accordion = $(this).closest('.accordion');
            var $trigger = $(this).closest('dt');
            var $content = $trigger.next();
            var $allContent = $('> dd', $accordion);
            var $allTriggers = $('> dt', $accordion);

            if ($trigger.hasClass('active')) {
                $allContent.slideUp();
                $allContent.removeClass('active');
                $trigger.removeClass('active');
                $accordion.addClass('initial');
            } else {
                $allContent.slideUp();
                $allContent.removeClass('active');
                $allTriggers.removeClass('active');
                $accordion.removeClass('initial');
                $trigger.addClass('active');
                $content.slideDown();
            }
        })

});